var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroller",class:_vm.classes,on:{"scroll":_vm.scrollHandler,"touchstart":_vm.touchstartHandler,"touchmove":_vm.touchmoveHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }